(function() {
// --- Configuration ---
// The URL for the API endpoint that identifies the Moodle version
const API_URL = 'https://workflow.tuchsoft.com/webhook/moodleVersion';

// --- Global State ---
let currentClass = null; // Tracks the dynamically applied class for clearing on reset

// --- DOM Elements (Selected with jQuery where possible) ---
const $form = $('#version-form');
const $urlInput = $('#form-input-url');
const $submitButton = $('#version-form .btn-primary');
const $messageArea = $('#message-area');
const $versionResult = $('#version-result');
const $moodleVersionEl = $('#moodle-version');
const $moodleYearEl = $('.moodle-year');
const $steps = $("#steps");

/*
 * Plain-language copy for the cases where we could not read a
 * version. No technical detail is exposed; every case keeps a
 * way to reach us.
 */
const BLOCKED_REASON = {
    cloudflare: 'Your site is behind Cloudflare protection, which stops our tool from reading it. That is no problem: we can check it for you.',
    firewall: "Your site's security settings blocked our tool. That is no problem: we can check it for you."
};
const BLOCKED_FALLBACK = 'Your site blocked our automatic check. That is no problem: we can check it for you.';

const CONTACT_MESSAGE = 'Hello,\nWe would like to know which Moodle version our site at "[Site URL]" is running.\nThe online tool could not detect it, can you help us find out?\n';

/**
 * Shows a status message in the designated area and manages button state.
 * @param {string} text - The message text to display.
 * @param {string} type - 'success', 'error', or 'loading' to determine styling and button state.
 */
function showMessage(text, type) {
    // 1. Show the element (replaces d-none removal)
    $messageArea.text(text).fadeIn(500);

    if (type === 'loading') {
        $submitButton.prop('disabled', true); // Disable button while loading
        $submitButton.text('Checking...');
    }
}

/**
 * Resets the UI to its initial state, hiding results and clearing text content.
 */
function clearResults() {
    $('#moodle-version-identifier .d-none').hide(0).removeClass('d-none');

    // Hide all comment sections and the main result area
    $versionResult.fadeOut();
    $('#version-comment > div').fadeOut();
    $('.non-moodle').hide();
    $('#verdict-blocked, #verdict-unknown, #verdict-unreachable').hide();
    $('#nossl').hide();

    // Clear text content
    $messageArea.text('');
    $moodleVersionEl.text('');
    $moodleYearEl.text('');

    // Reset button state
    $submitButton.text('Check now!').prop('disabled', false);

    // Remove the 'selected' class from any currently selected card coin
    $('.card-coin.selected').removeClass('selected')
}

/**
 * Pre-fills the contact form with the site the visitor tried to check,
 * so getting in touch is one click.
 */
function prefillContact(url) {
    $('#message').val(CONTACT_MESSAGE.replace('[Site URL]', url));
    $('#org').val(url);
}

/**
 * Shows one of the "we could not read your version" messages.
 * @param {string} kind - 'blocked', 'unknown' or 'unreachable'.
 * @param {string} [reason] - for 'blocked': which protection we hit.
 */
function showVerdict(kind, reason) {
    $versionResult.fadeOut();
    $steps.fadeOut();
    $('.card-coin.selected').removeClass('selected');

    if (kind === 'blocked') {
        $('#blocked-reason').text(BLOCKED_REASON[reason] || BLOCKED_FALLBACK);
    }

    $('#verdict-' + kind).fadeIn(600);
    scrollTo('#version-result');

    prefillContact($urlInput.val().trim());
}

/**
 * Renders a detected version, exactly as before.
 */
function showVersion(data, url) {
    let steps = data.steps.map((s) => "<span class='blue'>"+s+"</span>").join('&nbsp;&gt;&nbsp;');

    $messageArea.fadeOut(200).text('');
    $moodleVersionEl.text(data.version);
    $moodleYearEl.text(data.year);

    $steps.find('span').html(steps)
    $('.card-coin.' + data.class).addClass('selected');

    $versionResult.fadeIn(600);
    $('.' + data.class).fadeIn(600);
    $steps.fadeIn(600);

    if (!data.ssl) {
        $('#nossl').fadeIn(600);
    }

    scrollTo('#version-result');

    if (isMobile()) {
        $('.card-coin').not('.selected').fadeOut(600);
        $('.card-coin.selected').fadeIn(600);
    }

    // Complete the "contact us" message with the data
    let text = $('#message').text()
        .replace('[Moodle Version]', data.version)
        .replace('[Site URL]', url);
    $('#message').val(text);
    $('#org').val(url);
}

// --- Form Submission Handler ---
$form.on('submit', async (e) => {
    e.preventDefault();

    const url = $urlInput.val().trim();

    if (!url) {
        showMessage('Please enter a valid Moodle URL.', 'error');
        return;
    }

    // Clear previous results and show loading indicator
    clearResults();
    showMessage('Checking...', 'loading');

    try {
        const response = await firebase('moodleVersion', { url: url });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`API call failed: ${response.status} - ${errorText}`);
        }

        const data = (await response.json());

        $messageArea.fadeOut();

        // --- Legacy response shapes (kept for safety) ---
        if (data === 'non-moodle') {
            $('.non-moodle').fadeIn(600);
            prefillContact(url);
            return;
        }

        if (data === false) {
            showVerdict('unreachable');
            return;
        }

        // --- Current response shape: every answer is an object with a "result" ---
        if (data && typeof data === 'object') {
            const result = data.result || (data.version ? 'version' : null);

            if (result === 'version') {
                if (typeof data.version === 'undefined' || typeof data.year === 'undefined' || typeof data.class === 'undefined') {
                    throw new Error('Received an invalid or incomplete response format from the server.');
                }

                showVersion(data, url);
                return;
            }

            if (result === 'not-moodle') {
                $('.non-moodle').fadeIn(600);
                prefillContact(url);
                return;
            }

            if (result === 'blocked') {
                showVerdict('blocked', data.reason);
                return;
            }

            if (result === 'unknown') {
                showVerdict('unknown');
                return;
            }

            if (result === 'unreachable') {
                showVerdict('unreachable');
                return;
            }

            if (result === 'invalid') {
                showMessage('Please enter a valid Moodle URL.', 'error');
                return;
            }
        }

        throw new Error('Received an invalid or incomplete response format from the server. Check function response structure.');

    } catch (error) {
        console.error("Error fetching Moodle data:", error);
        showMessage(`An error occurred: ${error.message}. Please check the URL and ensure the API is running.`, 'error');
    } finally {
        // Reset button text and state once the request is complete
        $submitButton.text('Check now!').prop('disabled', false);
    }
});
})();
